import { api } from './client.js';

export const teamApi = {
  listUsers: () => api('/team/users'),
  getUser: (id) => api(`/team/users/${id}`),
  updateUser: (id, body) => api(`/team/users/${id}`, { method: 'PATCH', body }),
  deleteUser: (id) => api(`/team/users/${id}`, { method: 'DELETE' }),
  listInvites: () => api('/auth/invites'),
  createInvite: (body) => api('/auth/invites', { method: 'POST', body }),
  revokeInvite: (id) => api(`/auth/invites/${id}`, { method: 'DELETE' }),
  changePassword: (old_password, new_password) =>
    api('/auth/change-password', {
      method: 'POST',
      body: { old_password, new_password },
    }),
  updateProfile: (body) => api('/auth/me/profile', { method: 'PATCH', body }),
};
